export default "__VITE_ASSET__BxCl_pJt__"